<div class="flex flex-col gap-1">
    <div *ngIf="data" class="number-stats">
        {{ data.current }}
        <span *ngIf="data.total" class="number-stats__total">/{{ data.total }}</span>
        <span *ngIf="!data.total" class="number-stats__percent">%</span>
    </div>
</div>
